import { useCallback } from 'react';
import { useAppDispatch } from 'src/app/hooks';
import { showSnackBar } from 'src/api/ui-slice';
import { ts } from 'src/utils/translate';

export function useSaveFeedback() {
    const dispatch = useAppDispatch();

    const showSaveSuccess = useCallback(() => {
        dispatch(showSnackBar({
            text: ts('project_settings_save_success', 'Project settings saved'),
            severity: 'success',
        }));
    }, [dispatch]);

    const showSaveError = useCallback(() => {
        dispatch(showSnackBar({
            text: ts('project_settings_save_error', 'Failed to save project settings'),
            severity: 'error',
        }));
    }, [dispatch]);

    return { showSaveSuccess, showSaveError };
}
